import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ImportedAchievement } from "types/achievements";

export interface InitialState {
  imported: ImportedAchievement[];
}

const initialState: InitialState = {
  imported: [],
};

export const achievementsSlice = createSlice({
  name: "achievements",
  initialState,
  reducers: {
    setImportedAchievements: (
      state,
      action: PayloadAction<ImportedAchievement[]>,
    ) => {
      state.imported = action.payload;
    },
    updateImportedAchievements: (
      state,
      action: PayloadAction<{
        importedId: number;
        achievement: ImportedAchievement;
      }>,
    ) => {
      state.imported = state.imported.map((achievement, index) => {
        if (index === action.payload.importedId) {
          return action.payload.achievement;
        }

        return achievement;
      });
    },
  },
});

export const { setImportedAchievements, updateImportedAchievements } =
  achievementsSlice.actions;

export const selectImportedAchievements = (state: RootState) =>
  state.achievements.imported;

export default achievementsSlice.reducer;
